/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/undefined/ngm-portal-jws/public/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "8ybw");
/******/ })
/************************************************************************/
/******/ ({

/***/ "4Mch":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ybw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__("4Mch");

var animationModule = function () {
  function animationModule() {
    _classCallCheck(this, animationModule);

    this.Init();
  }

  _createClass(animationModule, [{
    key: 'Init',
    value: function Init() {
      $('.JS_popup_close').on('click', function () {
        $('.popup').removeClass('show');
        $('.JS_popup_qrcode').removeClass('show');
        $('.JS_popup_pay').addClass('show');
      });

      $('.JS_popup').on('click', function () {
        var src = $(this).find('.img').attr('src');
        var desc = $(this).find('.desc').text();
        var type = $(this).find('.type').text();
        $('.JS_popup_img').attr('src', src);
        $('.JS_popup_desc').text(desc);
        $('.JS_popup_type').text(type);
        $('.JS_popup_pay').addClass('show');
        $('.popup').addClass('show');
      });

      $('.JS_popup_free').on('click', function () {
        var src = $(this).find('.img').attr('src');
        var desc = $(this).find('.desc').text();
        var type = $(this).find('.type').text();
        $('.JS_popup_img').attr('src', src);
        $('.JS_popup_desc').text(desc);
        $('.JS_popup_type').text(type);
        $('.JS_popup_pay').removeClass('show');
        $('.popup').addClass('show');
      });

      $('.JS_popup_pay').on('click', function () {
        $('.JS_popup_qrcode').addClass('show');
      });

      $('.JS_popup_qrcode').on('click', function () {
        $('.JS_popup_qrcode').removeClass('show');
      });
    }
  }]);

  return animationModule;
}();

new animationModule();

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/animation/index.c9009fb3.js